<app-header></app-header>
<div style="margin-top: 30px;" [hidden]="!processing">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div fxLayout="column" fxLayoutAlign="center center" class="card" *ngIf="!processing">
  <div *ngIf="!confirmed">
    <div>
      <mat-icon class="icon" color="primary">sentiment_very_dissatisfied</mat-icon>
      <div class="header">{{ 'ORDER_CANCELLATION.CONFIRMATION_ERROR.TITLE' | translate }}</div>
    </div>
    <div class="description">{{ 'ORDER_CANCELLATION.CONFIRMATION_ERROR.TEXT' | translate }}</div>

  </div>
  <div *ngIf="confirmed">
    <div>
      <mat-icon class="icon" color="primary">done_outline</mat-icon>
      <div class="header">{{ 'ORDER_CANCELLATION.CONFIRMATION.TITLE' | translate }}</div>
    </div>
    <div *ngIf="confirmationText == ''" class="description">{{ 'ORDER_CANCELLATION.CONFIRMATION.TEXT' | translate }}</div>
    <div *ngIf="confirmationText != ''" class="description" [innerHTML]="confirmationText"></div>
  </div>
</div>
